import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PaymentsListPage from './PaymentsListPage';

export default function PaymentsRoutes() {
  return (
    <Routes>
      <Route index element={<PaymentsListPage />} />
      <Route path="invoice/:invoiceId" element={<PaymentsListPage />} />
    </Routes>
  );
}
